import { Confidence } from '@spotify-confidence/sdk';
import { ConfidenceProvider, useEvaluateFlag } from '@spotify-confidence/react';

const confidence = Confidence.create({
  clientSecret: process.env.REACT_APP_CONFIDENCE_CLIENT_SECRET ?? '',
  environment: 'client',
  timeout: 3000
});

export { ConfidenceProvider, useEvaluateFlag, confidence };
